export const appsApiLimitsCompanySdkRateLimitDatatable = "/apps/api_limits/company_sdk_rate_limit_datatable";
